(function () {
  'use strict';

  var productsById = window.rcBundleProducts || {};
  var productsByVariant = window.rcBundleVariants || {};
  window.rcBundleProducts = productsById;
  window.rcBundleVariants = productsByVariant;

  window.registerRcBundleProduct = function (product) {
    if (!product || product.id == null) return;
    productsById[String(product.id)] = product;
    (product.variantIds || []).forEach(function (variantId) {
      productsByVariant[String(variantId)] = product;
    });
  };

  function lookup(variantId) {
    if (variantId == null || variantId === '') return null;
    return productsByVariant[String(variantId)] || null;
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = String(url);
      if (path.charAt(0) === '/') path = path.split('?')[0];
      else path = new URL(path, window.location.origin).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add/.test(String(url));
    }
  }

  function applyToProperties(properties, info) {
    var next = properties && typeof properties === 'object' ? properties : {};
    if (!next._bundle_id) next._bundle_id = info.handle;
    if (!next._bundle_title) next._bundle_title = info.title;
    if (info.skus && !next._bundle_skus) next._bundle_skus = info.skus;
    return next;
  }

  function appendBundleFields(body, prefix, info) {
    if (!body.get(prefix + '[_bundle_id]')) {
      body.append(prefix + '[_bundle_id]', info.handle);
      body.append(prefix + '[_bundle_title]', info.title);
    }
    if (info.skus && !body.get(prefix + '[_bundle_skus]')) {
      body.append(prefix + '[_bundle_skus]', info.skus);
    }
    return body;
  }

  function applyToItem(item) {
    if (!item || typeof item !== 'object') return item;
    var info = lookup(item.id || item.variant_id);
    if (!info) return item;
    item.properties = applyToProperties(item.properties, info);
    return item;
  }

  function injectFormData(body) {
    var id = body.get('id') || body.get('items[0][id]');
    var info = lookup(id);
    if (!info) return body;
    if (body.get('items[0][id]')) {
      appendBundleFields(body, 'items[0][properties]', info);
    } else {
      appendBundleFields(body, 'properties', info);
    }
    return body;
  }

  function injectUrlSearchParams(body) {
    var id = body.get('id') || body.get('items[0][id]');
    var info = lookup(id);
    if (!info) return body;
    if (body.get('items[0][id]')) {
      appendBundleFields(body, 'items[0][properties]', info);
    } else {
      appendBundleFields(body, 'properties', info);
    }
    return body;
  }

  function injectJsonString(text) {
    if (!text) return text;
    try {
      var data = JSON.parse(text);
      if (Array.isArray(data.items)) {
        data.items.forEach(applyToItem);
      } else {
        applyToItem(data);
      }
      return JSON.stringify(data);
    } catch (e) {
      return text;
    }
  }

  function injectBody(body) {
    if (!body) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return injectFormData(body);
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return injectUrlSearchParams(body);
    }
    if (typeof body === 'string') {
      var trimmed = body.replace(/^\s+/, '');
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        return injectJsonString(body);
      }
      try {
        return injectUrlSearchParams(new URLSearchParams(body)).toString();
      } catch (e) {
        return body;
      }
    }
    if (typeof body === 'object' && !body.arrayBuffer) {
      applyToItem(body);
      if (Array.isArray(body.items)) body.items.forEach(applyToItem);
    }
    return body;
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (!isCartAddUrl(url)) {
        return originalFetch.apply(this, arguments);
      }

      if (typeof Request !== 'undefined' && input instanceof Request) {
        var request = input;
        var requestType = request.headers.get('Content-Type') || '';
        if (requestType.indexOf('multipart/form-data') !== -1) {
          return originalFetch.apply(this, arguments);
        }
        return request
          .clone()
          .text()
          .then(function (text) {
            var contentType = request.headers.get('Content-Type') || '';
            var nextBody = text;
            if (contentType.indexOf('application/json') !== -1 || (text && (text.charAt(0) === '{' || text.charAt(0) === '['))) {
              nextBody = injectJsonString(text);
            } else if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
              nextBody = injectUrlSearchParams(new URLSearchParams(text)).toString();
            }
            return originalFetch.call(window, new Request(request, { body: nextBody }));
          });
      }

      init = init ? Object.assign({}, init) : {};
      init.body = injectBody(init.body);
      return originalFetch.call(window, input, init);
    };
  }

  var originalXhrOpen = XMLHttpRequest.prototype.open;
  var originalXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._rcBundleCartAdd = isCartAddUrl(url);
    return originalXhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._rcBundleCartAdd) {
      body = injectBody(body);
    }
    return originalXhrSend.call(this, body);
  };
})();
